import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Importar páginas
import Portada from '@/pages/portada/'

export default new Router({
  routes: [
      {
        path: '/',
        name: 'portada',
        component: Portada
      }
  ]
})
